import angular from 'angular';

const $inject = ['moment', '$filter', 'ENUMS', 'dateTimeService', 'settingsService'];

const sectorService = function sectorService(moment, $filter, ENUMS, dateTimeService, settingsService) {
  return {
    reorder: reorder,
    abridge: abridge,
    priceSummary: priceSummary,
    currentStatus: currentStatus,
    abridgeCurrentItinerary: abridgeCurrentItinerary,
    getSeatMapAvailable: getSeatMapAvailable,
    getPolicyDisabled: getPolicyDisabled,
    getMatchingPolicyItem: getMatchingPolicyItem,
  };

  function reorder(obj) {
    let allSectors = [].concat(obj.Flights, obj.Rails, obj.Hotels, obj.Cars, obj.GroundTransports);
    let sectorTypeOrder = ['flight', 'rail', 'hotel', 'car', 'ground'];

    angular.forEach(allSectors, function (sector) {
      if (sector.Carrier) {
        sector.sectorType = sectorTypeOrder[0];
        sector.date = sector.Departure.Date;
      }

      if (sector.RailNumber) {
        sector.sectorType = sectorTypeOrder[1];
        sector.date = sector.Departure.Date;
      }

      if (sector.HotelName) {
        sector.sectorType = sectorTypeOrder[2];
        sector.date = sector.DateFrom;
      }

      if (sector.PickUp) {
        sector.sectorType = sectorTypeOrder[3];
        sector.date = sector.PickUp.Date;
      }

      if (sector.StartDateTime) {
        sector.sectorType = sectorTypeOrder[4];
        sector.date = sector.StartDateTime;
      }
    });

    allSectors.sort(function (x, y) {
      let n = moment(x.date, 'YYYY-MM-DD').format('YYYYMMDD') - moment(y.date, 'YYYY-MM-DD').format('YYYYMMDD');

      return n !== 0 ? n : sectorTypeOrder.indexOf(x.sectorType) - sectorTypeOrder.indexOf(y.sectorType);
    });

    return allSectors;
  }

  function abridge(sectors) {
    let trip = {
      travelType: '',
      flights: [],
      hotels: [],
      grounds: [],
      land: [],
      cars: [],
    };

    angular.forEach(sectors, function (sector) {
      let location = {};

      if (sector.sectorType === 'flight' || sector.sectorType === 'rail') {
        location.startLocation = sector.Departure.Code;
        location.endLocation = sector.Arrival.Code;
        location.startDate = sector.Departure.Date;
        location.endDate = sector.Arrival.Date;

        trip.flights.push(location);
      }

      if (sector.sectorType === 'hotel') {
        location.startLocation = sector.Location.Code;
        location.endLocation = sector.Location.Code;
        location.startDate = sector.DateFrom;
        location.endDate = sector.DateTo;

        trip.hotels.push(location);
        trip.land.push(location);
      }

      if (sector.sectorType === 'car') {
        location.startLocation = sector.PickUp.Code;
        location.endLocation = sector.DropOff.Code;
        location.startDate = sector.PickUp.Date;
        location.endDate = sector.DropOff.Date;

        trip.cars.push(location);
        trip.land.push(location);
      }

      if (sector.sectorType === 'ground') {
        location.startLocation = sector.Route[0].Type;
        location.endLocation = sector.Route[0].Type;
        location.startDate = sector.StartDateTime;
        location.endDate = sector.StartDateTime;

        trip.grounds.push(location);
        trip.land.push(location);
      }
    });

    SetTripAbrigdeDetails(trip);
    return trip;
  }

  function abridgeCurrentItinerary(sectors) {
    let trip = {
      travelType: '',
      flights: [],
      hotels: [],
      grounds: [],
      land: [],
      cars: [],
    };

    angular.forEach(sectors, function (sector) {
      let location = {
        startDate: sector.dateOrder,
      };

      if (sector.type === 'flight') {
        location.startLocation = sector.Start.Airport.Code;
        location.endLocation = sector.End.Airport.Code;
        location.startDate = sector.Start.DateLocal;
        location.endDate = sector.End.DateLocal;
        location.startDateUTC = sector.Start.Date;
        location.endDateUTC = sector.End.Date;

        trip.flights.push(location);
      }
      if (sector.type === 'rail') {
        location.startLocation = sector.Start.Station.Code;
        location.endLocation = sector.End.Station.Code;
        location.startDate = sector.Start.DateLocal;
        location.endDate = sector.End.DateLocal;
        location.startDateUTC = sector.Start.Date;
        location.endDateUTC = sector.End.Date;

        trip.flights.push(location);
      }

      if (sector.type === 'hotel') {
        location.startLocation = sector.Location.CityCode;
        location.endLocation = sector.Location.CityCode;
        location.startDate = sector.Start.DateLocal;
        location.endDate = sector.End.DateLocal;
        location.startDateUTC = sector.Start.Date;
        location.endDateUTC = sector.End.Date;

        trip.hotels.push(location);
        trip.land.push(location);
      }

      if (sector.type === 'car') {
        location.startLocation = sector.Start.Location.CityCode;
        location.endLocation = sector.End.Location.CityCode;
        location.startDate = sector.Start.DateLocal;
        location.endDate = sector.End.DateLocal;
        location.startDateUTC = sector.Start.Date;
        location.endDateUTC = sector.End.Date;

        trip.cars.push(location);
        trip.land.push(location);
      }

      if (sector.type === 'ground') {
        location.startLocation = sector.PickupDetails;
        location.endLocation = sector.DropOffDetails;
        location.startDate = sector.DateLocal;
        location.endDate = sector.DateLocal;
        let utcDate = moment.utc(sector.dateOrder).format('YYYYMMDDTHHmmssZ');
        utcDate = utcDate.substring(0, utcDate.indexOf('+'));
        location.startDateUTC = utcDate;
        location.endDateUTC = utcDate;

        trip.grounds.push(location);
        trip.land.push(location);
      }
    });

    SetTripAbrigdeDetails(trip);
    return trip;
  }

  function SetTripAbrigdeDetails(trip) {
    const DATE_FORMAT_LONG = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_LONG);
    let start;
    let end;
    let startUTC;
    let endUTC;

    if (trip.flights.length === 1) {
      trip.travelType = 'oneway';

      start = trip.flights[0].startDate;
      end = trip.flights[0].endDate;
      startUTC = trip.flights[0].startDateUTC;
      endUTC = trip.flights[0].endDateUTC;
    } else if (trip.flights.length === 2 && trip.flights[0].startLocation === trip.flights[trip.flights.length - 1].endLocation) {
      trip.travelType = 'return';

      start = trip.flights[0].startDate;
      end = trip.flights[1].endDate;
      startUTC = trip.flights[0].startDateUTC;
      endUTC = trip.flights[1].endDateUTC;
    } else if (trip.flights.length > 1) {
      trip.travelType = 'multi';

      start = trip.flights[0].startDate;
      end = trip.flights[trip.flights.length - 1].endDate;
      startUTC = trip.flights[0].startDateUTC;
      endUTC = trip.flights[trip.flights.length - 1].endDateUTC;
    } else {
      if (trip.hotels.length && trip.cars.length) {
        trip.travelType = 'land';

        start = trip.land[0].startDate;
        end = trip.land[trip.land.length - 1].endDate;
        startUTC = trip.land[0].startDateUTC;
        endUTC = trip.land[trip.land.length - 1].endDateUTC;
      } else if (trip.hotels.length) {
        trip.travelType = 'hotel';

        start = trip.hotels[0].startDate;
        end = trip.hotels[trip.hotels.length - 1].endDate;
        startUTC = trip.hotels[0].startDateUTC;
        endUTC = trip.hotels[trip.hotels.length - 1].endDateUTC;
      } else if (trip.cars.length) {
        trip.travelType = 'car';

        start = trip.cars[0].startDate;
        end = trip.cars[trip.cars.length - 1].endDate;
        startUTC = trip.cars[0].startDateUTC;
        endUTC = trip.cars[trip.cars.length - 1].endDateUTC;
      } else if (trip.grounds.length) {
        trip.travelType = 'ground';

        start = trip.grounds[0].startDate;
        end = trip.grounds[trip.grounds.length - 1].endDate;
        startUTC = trip.grounds[0].startDateUTC;
        endUTC = trip.grounds[0].endDateUTC;
      }
    }

    if (start && end) {
      let startMoment = moment(start, 'YYYY-MM-DD').startOf('day');
      let endMoment = moment(end, 'YYYY-MM-DD').startOf('day');

      trip.length = endMoment.diff(startMoment, 'days');
      trip.startDate = startMoment.format(DATE_FORMAT_LONG);
      trip.endDate = endMoment.format(DATE_FORMAT_LONG);
    }

    if (startUTC && endUTC) {
      trip.startDateUTC = startUTC.replace(/[\W_]+/g, '') + 'Z';
      trip.endDateUTC = endUTC.replace(/[\W_]+/g, '') + 'Z';
    }

    trip.title = tripTitle(trip);
  }

  function priceSummary(sectors, currentItinerarySegments, config) {
    const priceTotals = {
      Flight: [],
      Rail: [],
      Hotel: [],
      Car: [],
      GroundTransport: [],
      Seat: [],
      Ancillary: [],
      flights: 0,
      rails: 0,
      hotels: 0,
      cars: 0,
      grounds: 0,
      combined: 0,
      lostSavings: 0,
      sectorSavings: [],
    };

    var groupedSectors = {};

    _.forEach(config.PaymentMethod.PaymentItems, (paymentMethod) => {
      paymentMethod = buildPaymentMethodTitle(paymentMethod, sectors);

      if (paymentMethod.Invoice) {
        paymentMethod.Invoice.titleArray = paymentMethod.sectorTitlesArray;
        priceTotals[paymentMethod.Type].push(paymentMethod.Invoice);
      } else {
        paymentMethod.Card.titleArray = paymentMethod.sectorTitlesArray;
        priceTotals[paymentMethod.Type].push(paymentMethod.Card);
      }
    });
    angular.forEach(sectors, function (sector) {
      priceTotals.lostSavings += sector.LostSavingsAmount;
      if (sector.LostSavingsAmount > 0) {
        var item = priceTotals.sectorSavings.find((s) => s.sectorType === sector.sectorType);
        let policyInfo = null;
        if (sector.Policy && sector.Policy.Code) {
          policyInfo = sector.Policy.Title ? `${sector.Policy.Title} (${sector.Policy.Code})` : sector.Policy.Code;
        }
        if (item) {
          item.savings += sector.LostSavingsAmount;
          item.policyInfo = policyInfo;
        } else {
          priceTotals.sectorSavings.push({
            sectorType: sector.sectorType,
            savings: sector.LostSavingsAmount,
            policyInfo: policyInfo,
          });
        }
      }
      if (sector.sectorType === 'flight') {
        priceTotals.flights += sector.TotalAmount;
      }

      if (sector.sectorType === 'rail') {
        var sectorIdentifier = `${sector.RailNumber}-${sector.Departure.Code}-${sector.Arrival.Code}-${sector.Departure.Date}`;
        if (!Object.hasOwn(groupedSectors, sectorIdentifier)) {
          groupedSectors[sectorIdentifier] = {};
          priceTotals.rails += sector.TotalAmount;
        }
      }
    });

    angular.forEach(currentItinerarySegments, (segment) => {
      if (segment.type === 'hotel') {
        if (segment.TotalCost != null) {
          priceTotals.hotels += segment.TotalCost.Amount;
          priceTotals.disclaimer = segment.TotalCost.Disclaimer;
        } else {
          let startMoment = moment(segment.Start.Date, 'YYYY-MM-DD').startOf('day');
          let endMoment = moment(segment.End.Date, 'YYYY-MM-DD').startOf('day');
          let days = endMoment.diff(startMoment, 'days');

          priceTotals.hotels += segment.Rate.Amount * days;
        }
      }
      if (segment.type === 'car' && segment.TotalCost) {
        priceTotals.cars += segment.TotalCost.Amount;
      }

      if (segment.type === 'ground' && segment.Rate) {
        priceTotals.grounds += segment.Rate.Amount;
      }
    });

    priceTotals.combined = priceTotals.flights + priceTotals.rails + priceTotals.hotels + priceTotals.cars + priceTotals.grounds;

    return priceTotals;
  }

  function currentStatus(passenger) {
    let approvalStates = {
      Auto: {
        id: 'AU',
        message: 'Auto approval',
        class: 'approvalApproved',
      },
      Pending: {
        id: 'AW',
        message: 'Awaiting approval',
        class: 'approvalPending',
      },
      Approved: {
        id: 'AP',
        message: 'Approved',
        class: 'approvalApproved',
      },
      Declined: {
        id: 'DN',
        message: 'Denied',
        class: 'approvalDenied',
      },
      Expired: {
        id: 'EX',
        message: 'Expired',
        class: 'approvalExpired',
      },
      // LOBT-2525 Frontend - My Bookings Confirm booking on hold
      UserHold: {
        id: 'UH',
        message: 'User Hold',
        class: 'approvalPending',
      },
    };

    return approvalStates[passenger.ApprovalState];
  }

  function tripTitle(trip) {
    switch (trip.travelType) {
      case 'oneway':
        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
        break;
      case 'return':
        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
        break;
      case 'multi':
        return _.join(_.map(trip.flights, 'startLocation'), ' > ');
        break;
      case 'land':
        return 'Hotel and Car Booking';
        break;
      case 'hotel':
        return 'Hotel booking';
        break;
      case 'car':
        return 'Car booking';
        break;
      case 'ground':
        return 'Ground booking';
        break;
      default:
        return 'Lightning booking';
    }
  }

  function buildPaymentMethodTitle(paymentMethod, sectors) {
    const grpId = paymentMethod.SectorGroupIdentifier;

    paymentMethod.sectorTitlesArray = [];

    _.forEach(sectors, (sector) => {
      if (sector.GroupIdentifier === grpId && sector.sectorType === 'flight') {
        paymentMethod.sectorTitlesArray.push(sector.Carrier + ' ' + sector.FlightNumber);
      }
    });

    return paymentMethod;
  }

  function getSeatMapAvailable(booking) {
    if (booking && booking.Flights) {
      if (_.some(booking.Flights, (flight) => flight.SeatMapAvailable)) {
        return true;
      }
    }
    if (booking && booking.CurrentItinerary && booking.CurrentItinerary.Air) {
      if (_.some(booking.CurrentItinerary.Air, (flight) => flight.SeatMapAvailable)) {
        return true;
      }
    }
  }

  function getPolicyDisabled(sector, selectedTravelers, reasonForTravel) {
    let sectorSettings = settingsService.settings[sector + 'Configuration'];
    if (!sectorSettings) {
      sectorSettings = settingsService.settings[sector];
    }

    if (!sectorSettings) return true;
    if ('Enable' in sectorSettings && !sectorSettings.Enable) return false;
    if ('Enabled' in sectorSettings && !sectorSettings.Enabled) return false;
    if (sectorSettings[sector + 'Enabled'] === false) return false;

    const disablesName = sector === 'GroundTransportation' ? 'GroundTrans' : sector;
    const policyDisables = sectorSettings[disablesName + 'PolicyDisables'];
    const policyKey = 'Disable' + sector;
    let sectorEnabled = true;
    if (!policyDisables || !policyDisables.length) return true;

    //If any set it to disable go ahead and disable.
    //This covers when no travelers are selected so it defaults the traveler
    const policyDisable = policyDisables.find((policy) => policy[policyKey]);
    if (policyDisable) sectorEnabled = !policyDisable[policyKey];

    let employeeCode = null;
    if (selectedTravelers && selectedTravelers.length) {
      employeeCode = selectedTravelers[0].EmployeeCode; //Only Look at first traveler
    }

    let policyFind = getMatchingPolicyItem(employeeCode, reasonForTravel, policyDisables);
    if (policyFind) {
      sectorEnabled = !policyFind[policyKey];
      return sectorEnabled;
    }

    return sectorEnabled;
  }
};

function getMatchingPolicyItem(employeeCode, reasonForTravel, polcies) {
  // most restrictive policy applies for example AgencyReasonCodes & EmployeeTypes policy applies first over EmployeeTypes only policy and AgencyReasonCodes only policy
  //matches backend itineraryPolicyManager.cs logic
  let levels = [];
  levels.push(
    polcies.filter(
      (policy) => policy.AgencyReasonCodes && policy.AgencyReasonCodes.length && policy.EmployeeTypes && policy.EmployeeTypes.length
    )
  );

  levels.push(polcies.filter((policy) => policy.EmployeeTypes && policy.EmployeeTypes.length));
  levels.push(polcies.filter((policy) => policy.AgencyReasonCodes && policy.AgencyReasonCodes.length));
  levels.push(polcies);
  let policyFind = null;
  levels.forEach((level) => {
    if (policyFind) return;
    policyFind = _.find(level, (policy) => {
      if (policy.AgencyReasonCodes && policy.AgencyReasonCodes.length > 0) {
        if (!reasonForTravel) return false;
        if (policy.AgencyReasonCodes.indexOf(reasonForTravel.Value) < 0) return false;
      }
      if (policy.EmployeeTypes && policy.EmployeeTypes.length > 0) {
        if (!employeeCode) return false;
        if (policy.EmployeeTypes.indexOf(employeeCode) < 0) return false;
      }
      return true;
    });
    if (policyFind) {
      return policyFind;
    }
  });
  return policyFind;
}
sectorService.$inject = $inject;

export default sectorService;



// WEBPACK FOOTER //
// ./src/services/sectorService.js